import { DisplayAuthoringPropertyPipe, InheritPipe, IsRequiredPropertyPipe } from '@adaptiva/metadata/common';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ComboComponentModule } from '@adaptiva/widgets/combo';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { ListBuilderComponentModule } from '@adaptiva/widgets/list-builder';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { ToggleSwitchComponent } from '@adaptiva/widgets/toggle-switch';
import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { AuthoringPropertyLabelComponentModule } from '../authoring-property-label-component';
import { RiskPropertiesComponent } from './risk-properties.component';

const WIDGETS: Type<any>[] = [
	AuthoringPropertyLabelComponentModule,
	CardComponentModule,
	ComboComponentModule,
	ContainerComponentModule,
	InputComponentModule,
	ListBuilderComponentModule,
	TextComponentModule,
	ToggleSwitchComponent,
];

@NgModule({
	imports: [
		CommonModule,
		DisplayAuthoringPropertyPipe,
		IsRequiredPropertyPipe,
		InheritPipe,
		WIDGETS
	],
	declarations: [RiskPropertiesComponent],
	exports: [RiskPropertiesComponent]
})
export class RiskPropertiesComponentModule {

}
